import React from 'react';
import { Avatar, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { UserAvatarContainer } from '../styles';

export const UserAvatar = ({ assignedTo }) => {
  const users = useSelector(state => state.users || []);
  
  // Find the assigned user
  const assignedUser = users.find(user => user.id === assignedTo);
  
  // Don't render if no user found
  if (!assignedUser) {
    return null;
  }
  
  // Get user initials for avatar
  const getUserInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  };
  
  // Get user avatar color based on ID
  const getAvatarColor = (userId) => {
    const colors = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae', '#87d068', '#ff7875', '#40a9ff'];
    return colors[userId % colors.length];
  };
  
  return (
    <UserAvatarContainer>
      <Tooltip title={`Responsável: ${assignedUser.name}`} placement="topRight">
        <Avatar
          size={20}
          style={{
            backgroundColor: getAvatarColor(assignedUser.id),
            color: '#fff',
            fontSize: '10px',
            cursor: 'pointer'
          }}
        >
          {getUserInitials(assignedUser.name)}
        </Avatar>
      </Tooltip>
    </UserAvatarContainer>
  );
};